module.exports = __webpack_public_path__ + "img/bbotox.718579b7.jpg";